import React, { useState } from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { toast } from 'sonner';
import { Mail, MapPin, User } from 'lucide-react';

const ContactSection = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Frontend only - show success message
    toast.success('Message sent successfully! We will contact you soon.');
    
    // Reset form
    setFormData({
      name: '',
      email: '',
      company: '',
      message: ''
    });
  };

  return (
    <section id="contact" className="py-32 bg-white">
      <div className="max-w-7xl mx-auto px-8">
        <div className="text-center mb-24">
          <p className="text-emerald-700 text-sm font-medium tracking-widest uppercase mb-6">Contact Us</p>
          <h2 className="text-5xl md:text-6xl font-light text-gray-900 mb-12 tracking-tight">
            Get in Touch
          </h2>
        </div>

        <div className="grid md:grid-cols-5 gap-16">
          {/* Contact Information */}
          <div className="md:col-span-2 space-y-10">
            <p className="text-xl text-gray-600 leading-relaxed font-light">
              For inquiries about our products and export services, please contact us directly.
            </p>

            <div className="space-y-8 pt-8">
              <div className="flex items-start space-x-5">
                <div className="mt-1">
                  <User className="w-6 h-6 text-emerald-700" strokeWidth={1.5} />
                </div>
                <div>
                  <p className="text-sm text-gray-500 mb-1 uppercase tracking-wider">Contact Person</p>
                  <p className="text-lg text-gray-900 font-light">Kairat Otarbayev</p>
                </div>
              </div>

              <div className="flex items-start space-x-5">
                <div className="mt-1">
                  <Mail className="w-6 h-6 text-emerald-700" strokeWidth={1.5} />
                </div>
                <div>
                  <p className="text-sm text-gray-500 mb-1 uppercase tracking-wider">Email</p>
                  <a
                    href="mailto:irgizexport@gmail.com"
                    className="text-lg text-emerald-700 hover:text-emerald-800 transition-colors font-light"
                  >
                    irgizexport@gmail.com
                  </a>
                </div>
              </div>

              <div className="flex items-start space-x-5">
                <div className="mt-1">
                  <MapPin className="w-6 h-6 text-emerald-700" strokeWidth={1.5} />
                </div>
                <div>
                  <p className="text-sm text-gray-500 mb-1 uppercase tracking-wider">Company</p>
                  <p className="text-lg text-gray-900 font-light">Irgiz Export LLP</p>
                  <p className="text-gray-600 font-light">Kazakhstan</p>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="md:col-span-3 bg-gray-50 p-12 shadow-xl">
            <form onSubmit={handleSubmit} className="space-y-7">
              <div>
                <label htmlFor="name" className="block text-sm text-gray-600 mb-3 uppercase tracking-wider">
                  Name *
                </label>
                <Input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="w-full h-12 bg-white border-gray-300 font-light text-lg"
                  placeholder="Your name"
                />
              </div>

              <div>
                <label htmlFor="email" className="block text-sm text-gray-600 mb-3 uppercase tracking-wider">
                  Email *
                </label>
                <Input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full h-12 bg-white border-gray-300 font-light text-lg"
                  placeholder="your.email@company.com"
                />
              </div>

              <div>
                <label htmlFor="company" className="block text-sm text-gray-600 mb-3 uppercase tracking-wider">
                  Company
                </label>
                <Input
                  type="text"
                  id="company"
                  name="company"
                  value={formData.company}
                  onChange={handleChange}
                  className="w-full h-12 bg-white border-gray-300 font-light text-lg"
                  placeholder="Your company name"
                />
              </div>

              <div>
                <label htmlFor="message" className="block text-sm text-gray-600 mb-3 uppercase tracking-wider">
                  Message *
                </label>
                <Textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows={5}
                  className="w-full bg-white border-gray-300 font-light text-lg"
                  placeholder="Your message..."
                />
              </div>

              <Button
                type="submit"
                className="w-full bg-emerald-700 hover:bg-emerald-600 text-white py-7 text-lg font-normal transition-colors tracking-wide"
              >
                Send Message
              </Button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
